var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentFilters && _vm.currentFilters.length && _vm.$mq !== "mobile"
    ? _c("div", { staticClass: "collection-filters" }, [
        _c("span", { staticClass: "collection-filters__title" }),
        _c(
          "div",
          { staticClass: "collection-filters__active-filters" },
          [
            _vm._l(_vm.currentFilters, function(filter) {
              return _c(
                "div",
                {
                  staticClass: "collection-filters__active-filter",
                  on: {
                    click: function($event) {
                      return _vm.removeFilter(filter)
                    }
                  }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.splitAndDecodeFilter(filter)))
                  ]),
                  _c("icon", { attrs: { name: "close", size: "10px" } })
                ],
                1
              )
            }),
            _c(
              "div",
              { staticClass: "collection-filters__filters-clear" },
              [
                _vm.currentFilters.length
                  ? _c(
                      "v-link",
                      {
                        staticClass: "text-sm",
                        attrs: { secondary: true },
                        on: { click: _vm.removeAllFilters }
                      },
                      [_vm._v("Clear All")]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }